var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c("vs-icon", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: "Ver detalle",
            expression: "'Ver detalle'"
          }
        ],
        staticClass: "cursor-pointer mt-4",
        attrs: { icon: "search", size: "medium", "data-cy": "details" },
        on: {
          click: function($event) {
            return _vm.showApproval(_vm.item.id)
          }
        }
      }),
      _c(
        "b-dropdown",
        {
          attrs: { variant: "light", "no-caret": "", right: "" },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function() {
                return [
                  _c("vs-icon", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Administrar",
                        expression: "'Administrar'"
                      }
                    ],
                    staticClass: "cursor-pointer",
                    attrs: {
                      icon: "more_vert",
                      size: "small",
                      "data-cy": "gear-button"
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-dropdown-item",
            {
              attrs: { "data-cy": "approvals-binnacle" },
              on: {
                click: function($event) {
                  return _vm.showBinnacle(_vm.item.id)
                }
              }
            },
            [
              _c("vs-icon", {
                attrs: { icon: "list", "data-cy": "approvals-binnacle-icon" }
              }),
              _c("span", [_vm._v(" Bitácora ")])
            ],
            1
          ),
          _c(
            "b-dropdown-item",
            {
              attrs: { "data-cy": "approvals-edit" },
              on: {
                click: function($event) {
                  return _vm.editApproval(_vm.item.id)
                }
              }
            },
            [
              _c("vs-icon", { attrs: { icon: "edit", "data-cy": "edit" } }),
              _c("span", [_vm._v(" Editar aprobación ")])
            ],
            1
          ),
          _c(
            "b-dropdown-item",
            {
              attrs: { "data-cy": "approvals-duplicate" },
              on: {
                click: function($event) {
                  return _vm.duplicateApproval(_vm.item.id)
                }
              }
            },
            [
              _c("vs-icon", {
                attrs: { icon: "library_add", "data-cy": "library_add" }
              }),
              _c("span", [_vm._v(" Duplicar aprobación ")])
            ],
            1
          ),
          !_vm.item.in_progress
            ? _c(
                "b-dropdown-item",
                {
                  attrs: { "data-cy": "approvals-delete" },
                  on: {
                    click: function($event) {
                      return _vm.deleteApproval(_vm.item.id)
                    }
                  }
                },
                [
                  _c("vs-icon", {
                    attrs: { icon: "delete", "data-cy": "delete" }
                  }),
                  _c("span", [_vm._v(" Eliminar aprobación ")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "watchModal",
          attrs: {
            size: "xl",
            "hide-footer": "",
            centered: "",
            title: "Detalles"
          }
        },
        [
          _c(
            "div",
            { staticClass: "scroll" },
            [_c("SeeTemplate", { attrs: { approvalId: _vm.approvalId } })],
            1
          )
        ]
      ),
      _c("modal-binnacle", {
        ref: "modalBinnacle",
        attrs: { title: "Bitácora de plantilla de aprobación" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }